import Vue from 'vue';
import Vuetify from 'vuetify';
import { VDatePicker } from 'vuetify/lib';
import fi from 'vuetify/lib/locale/fi';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

// Päivämäärävalitsimet: viikko alkaa maanantaista ja viikkonumerot näkyvät ISO 8601:n mukaan.
// Vuetify 2:ssa ei ole näille globaalia asetusta, joten muutetaan propsien oletukset. Templatet käyttävät
// vuetify-loaderin tuomaa vuetify/lib-komponenttia, globaali rekisteröinti on dist-paketista: muutetaan molemmat.
[VDatePicker, Vue.component('VDatePicker')].forEach(component => {
  component.options.props.firstDayOfWeek.default = 1;
  component.options.props.showWeek.default = true;
  component.options.props.localeFirstDayOfYear.default = 4;
});

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { fi },
    current: 'fi',
  },
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes: {
      light: {
        primary: '#007090',
        secondary: '#3968a8',
        accent: '#4E87EF',
        error: '#F4511E',
        warning: '#ff9800',
        info: '#40c4ff',
        success: '#66bb6a',
        default: '#dbdbdb',
      },
      dark: {
        primary: '#007090',
        secondary: '#3968a8',
        accent: '#4E87EF',
        error: '#F4511E',
        warning: '#ff9800',
        info: '#40c4ff',
        success: '#66bb6a',
        default: '#dbdbdb',
      },
    },
  },
});
